import React, { useState, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FolderIcon, FileTextIcon, UploadIcon, PlusIcon, SearchIcon, FolderPlusIcon, CalendarIcon, ClockIcon, TagIcon, MoreHorizontalIcon, FileIcon, TrashIcon, PencilIcon, CloudIcon, ExternalLinkIcon, LinkIcon, ChevronDownIcon, CheckIcon, DatabaseIcon, SettingsIcon, RefreshCwIcon } from 'lucide-react';
import Button from './common/Button';
// Document Viewer Component
const DocumentViewer = ({
  file,
  onBack,
  dropboxConnected,
  oneDriveConnected,
  showDownloadOptions,
  setShowDownloadOptions,
  handleDownload
}) => {
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-550">
      <div className="p-4 border-b border-gray-200" data-id="element-551">
        <div className="flex justify-between items-center" data-id="element-552">
          <div className="flex items-center" data-id="element-553">
            <button className="mr-3 text-gray-500 hover:text-gray-700" onClick={onBack} data-id="element-554">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-555">
                <path d="M19 12H5M12 19l-7-7 7-7" data-id="element-556" />
              </svg>
            </button>
            <FileIcon className="w-5 h-5 text-blue-500 mr-2" data-id="element-557" />
            <h2 className="text-lg font-medium text-gray-900" data-id="element-558">{file.name}</h2>
            {file.source && <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded" data-id="element-559">
                {file.source}
              </span>}
          </div>
          <div className="flex items-center gap-2" data-id="element-560">
            <div className="relative" data-id="element-561">
              <Button size="sm" variant="outline" onClick={() => setShowDownloadOptions(!showDownloadOptions)} data-id="element-562">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1" data-id="element-563">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" data-id="element-564" />
                </svg>
                Download
                <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-565" />
              </Button>
              {showDownloadOptions && <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg z-10 border border-gray-200" data-id="element-566">
                  <ul className="py-1" data-id="element-567">
                    <li data-id="element-568">
                      <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" onClick={() => handleDownload('local')} data-id="element-569">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-gray-500" data-id="element-570">
                          <rect x="2" y="2" width="20" height="8" rx="2" ry="2" data-id="element-571"></rect>
                          <rect x="2" y="14" width="20" height="8" rx="2" ry="2" data-id="element-572"></rect>
                          <line x1="6" y1="6" x2="6.01" y2="6" data-id="element-573"></line>
                          <line x1="6" y1="18" x2="6.01" y2="18" data-id="element-574"></line>
                        </svg>
                        Download to Device
                      </button>
                    </li>
                    {oneDriveConnected && <li data-id="element-575">
                        <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" onClick={() => handleDownload('onedrive')} data-id="element-576">
                          <CloudIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-577" />
                          Save to OneDrive
                        </button>
                      </li>}
                    {dropboxConnected && <li data-id="element-578">
                        <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" onClick={() => handleDownload('dropbox')} data-id="element-579">
                          <svg className="w-4 h-4 mr-2 text-blue-600" viewBox="0 0 24 24" fill="currentColor" data-id="element-580">
                            <path d="M12 0L6 6 0 0v6l6 6-6 6v6l6-6 6 6 6-6-6-6 6-6V0l-6 6z" data-id="element-581" />
                          </svg>
                          Save to Dropbox
                        </button>
                      </li>}
                    <li className="border-t border-gray-100" data-id="element-582">
                      <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" onClick={() => handleDownload('email')} data-id="element-583">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-gray-500" data-id="element-584">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" data-id="element-585"></path>
                          <polyline points="22,6 12,13 2,6" data-id="element-586"></polyline>
                        </svg>
                        Email as Attachment
                      </button>
                    </li>
                  </ul>
                </div>}
            </div>
            <Button size="sm" variant="outline" data-id="element-587">
              <PencilIcon className="w-4 h-4 mr-1" data-id="element-588" />
              Edit
            </Button>
            <Button size="sm" variant="danger" data-id="element-589">
              <TrashIcon className="w-4 h-4 mr-1" data-id="element-590" />
              Delete
            </Button>
          </div>
        </div>
      </div>
      <div className="p-6" data-id="element-591">
        <div className="mb-6" data-id="element-592">
          <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-593">
            File Information
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm" data-id="element-594">
            <div data-id="element-595">
              <p className="text-gray-500" data-id="element-596">Type</p>
              <p className="font-medium" data-id="element-597">{file.type}</p>
            </div>
            <div data-id="element-598">
              <p className="text-gray-500" data-id="element-599">Size</p>
              <p className="font-medium" data-id="element-600">{file.size}</p>
            </div>
            <div data-id="element-601">
              <p className="text-gray-500" data-id="element-602">Uploaded</p>
              <p className="font-medium" data-id="element-603">{file.date}</p>
            </div>
            <div data-id="element-604">
              <p className="text-gray-500" data-id="element-605">Tags</p>
              <div className="flex flex-wrap gap-1 mt-1" data-id="element-606">
                {file.tags.map((tag, index) => <span key={index} className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs" data-id="element-607">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
        {/* Document Preview - this would be replaced with an actual document viewer */}
        <div className="border border-gray-200 rounded-lg bg-gray-50 p-8 flex flex-col items-center justify-center min-h-[400px]" data-id="element-608">
          <FileIcon className="w-16 h-16 text-gray-300 mb-4" data-id="element-609" />
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-610">
            {file.name}
          </h3>
          <p className="text-gray-500 mb-6 text-center" data-id="element-611">
            Preview not available. Click the download button to view this file.
          </p>
          <div className="relative" data-id="element-612">
            <Button onClick={() => setShowDownloadOptions(true)} data-id="element-613">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-614">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" data-id="element-615" />
              </svg>
              Download File
              <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-616" />
            </Button>
          </div>
        </div>
      </div>
    </div>;
};
// Mock data for folders and files
const mockFolders = [{
  id: 'purchase',
  name: 'Purchase Documents',
  icon: <FileTextIcon className="w-5 h-5 text-blue-500" data-id="element-617" />,
  files: [{
    id: 'p1',
    name: 'Purchase Agreement.pdf',
    type: 'PDF',
    size: '2.4 MB',
    date: '2023-04-15',
    tags: ['Contract', 'Legal']
  }, {
    id: 'p2',
    name: 'Property Disclosure.pdf',
    type: 'PDF',
    size: '1.1 MB',
    date: '2023-04-16',
    tags: ['Disclosure']
  }, {
    id: 'p3',
    name: 'Title Report.pdf',
    type: 'PDF',
    size: '3.2 MB',
    date: '2023-04-20',
    tags: ['Title', 'Legal']
  }]
}, {
  id: 'escrow',
  name: 'Escrow Documents',
  icon: <FileTextIcon className="w-5 h-5 text-green-500" data-id="element-618" />,
  files: [{
    id: 'e1',
    name: 'Escrow Instructions.pdf',
    type: 'PDF',
    size: '1.7 MB',
    date: '2023-05-02',
    tags: ['Escrow', 'Legal']
  }, {
    id: 'e2',
    name: 'Closing Statement.pdf',
    type: 'PDF',
    size: '0.9 MB',
    date: '2023-05-15',
    tags: ['Closing', 'Financial']
  }]
}, {
  id: 'utility',
  name: 'Utility Documents',
  icon: <FileTextIcon className="w-5 h-5 text-yellow-500" data-id="element-619" />,
  files: [{
    id: 'u1',
    name: 'Electric Service.pdf',
    type: 'PDF',
    size: '0.6 MB',
    date: '2023-05-20',
    tags: ['Utility', 'Electric']
  }, {
    id: 'u2',
    name: 'Water Service.pdf',
    type: 'PDF',
    size: '0.5 MB',
    date: '2023-05-20',
    tags: ['Utility', 'Water']
  }, {
    id: 'u3',
    name: 'Internet Service.pdf',
    type: 'PDF',
    size: '0.4 MB',
    date: '2023-05-21',
    tags: ['Utility', 'Internet']
  }]
}, {
  id: 'construction',
  name: 'Construction Documents',
  icon: <FileTextIcon className="w-5 h-5 text-red-500" data-id="element-620" />,
  files: [{
    id: 'c1',
    name: 'Construction Contract.pdf',
    type: 'PDF',
    size: '4.2 MB',
    date: '2023-06-01',
    tags: ['Contract', 'Construction']
  }, {
    id: 'c2',
    name: 'Building Permits.pdf',
    type: 'PDF',
    size: '2.1 MB',
    date: '2023-06-10',
    tags: ['Permits', 'Legal']
  }, {
    id: 'c3',
    name: 'Architectural Plans.pdf',
    type: 'PDF',
    size: '15.8 MB',
    date: '2023-05-25',
    tags: ['Plans', 'Architecture']
  }, {
    id: 'c4',
    name: 'Contractor Bids.xlsx',
    type: 'XLSX',
    size: '1.3 MB',
    date: '2023-05-15',
    tags: ['Bids', 'Financial']
  }]
}, {
  id: 'tax',
  name: 'Property Tax Documents',
  icon: <FileTextIcon className="w-5 h-5 text-purple-500" data-id="element-621" />,
  files: [{
    id: 't1',
    name: 'Property Tax Bill 2023.pdf',
    type: 'PDF',
    size: '0.8 MB',
    date: '2023-07-01',
    tags: ['Tax', 'Financial']
  }, {
    id: 't2',
    name: 'Tax Assessment.pdf',
    type: 'PDF',
    size: '1.2 MB',
    date: '2023-06-15',
    tags: ['Assessment', 'Tax']
  }]
}];
// Mock data for OneDrive files
const mockOneDriveFiles = [{
  id: 'od1',
  name: 'Project Budget 2023.xlsx',
  type: 'XLSX',
  size: '1.8 MB',
  date: '2023-07-05',
  tags: ['Budget', 'Financial'],
  source: 'OneDrive'
}, {
  id: 'od2',
  name: 'Construction Timeline.docx',
  type: 'DOCX',
  size: '0.9 MB',
  date: '2023-07-02',
  tags: ['Timeline', 'Planning'],
  source: 'OneDrive'
}, {
  id: 'od3',
  name: 'Vendor Contacts.xlsx',
  type: 'XLSX',
  size: '0.5 MB',
  date: '2023-06-28',
  tags: ['Contacts', 'Vendors'],
  source: 'OneDrive'
}, {
  id: 'od4',
  name: 'Property Photos.zip',
  type: 'ZIP',
  size: '25.7 MB',
  date: '2023-06-15',
  tags: ['Photos', 'Property'],
  source: 'OneDrive'
}];
// Mock data for Dropbox files
const mockDropboxFiles = [{
  id: 'db1',
  name: 'Construction Contract Template.docx',
  type: 'DOCX',
  size: '1.2 MB',
  date: '2023-07-01',
  tags: ['Template', 'Contract'],
  source: 'Dropbox'
}, {
  id: 'db2',
  name: 'Property Management Guide.pdf',
  type: 'PDF',
  size: '3.5 MB',
  date: '2023-06-28',
  tags: ['Guide', 'Management'],
  source: 'Dropbox'
}, {
  id: 'db3',
  name: 'Financial Projections 2023.xlsx',
  type: 'XLSX',
  size: '1.7 MB',
  date: '2023-06-20',
  tags: ['Financial', 'Projections'],
  source: 'Dropbox'
}, {
  id: 'db4',
  name: 'Marketing Materials.zip',
  type: 'ZIP',
  size: '18.3 MB',
  date: '2023-06-15',
  tags: ['Marketing', 'Materials'],
  source: 'Dropbox'
}, {
  id: 'db5',
  name: 'Investor Presentation.pptx',
  type: 'PPTX',
  size: '5.8 MB',
  date: '2023-06-10',
  tags: ['Investor', 'Presentation'],
  source: 'Dropbox'
}];
// Mock QuickBooks data
const mockQuickBooksData = {
  connected: true,
  lastSync: '2023-07-10 09:45 AM',
  company: 'Real Estate Ventures LLC',
  availableReports: [{
    id: 'pl',
    name: 'Profit & Loss',
    lastGenerated: '2023-07-01'
  }, {
    id: 'bs',
    name: 'Balance Sheet',
    lastGenerated: '2023-07-01'
  }, {
    id: 'ap',
    name: 'Accounts Payable',
    lastGenerated: '2023-07-05'
  }, {
    id: 'ar',
    name: 'Accounts Receivable',
    lastGenerated: '2023-07-05'
  }, {
    id: 'exp',
    name: 'Expense Report',
    lastGenerated: '2023-07-08'
  }],
  recentTransactions: [{
    id: 't1',
    date: '2023-07-09',
    description: 'Home Depot - Construction Supplies',
    amount: -2456.78,
    category: 'Construction Expenses'
  }, {
    id: 't2',
    date: '2023-07-07',
    description: 'Rental Income - 123 Main St',
    amount: 1800.0,
    category: 'Rental Income'
  }, {
    id: 't3',
    date: '2023-07-05',
    description: 'City Utilities - Water & Sewer',
    amount: -187.45,
    category: 'Utilities'
  }, {
    id: 't4',
    date: '2023-07-03',
    description: 'Property Insurance Premium',
    amount: -650.0,
    category: 'Insurance'
  }, {
    id: 't5',
    date: '2023-07-01',
    description: 'Rental Income - 456 Oak Ave',
    amount: 2200.0,
    category: 'Rental Income'
  }]
};
const FileCabinet = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFolder, setSelectedFolder] = useState(mockFolders[0]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
  const [fileSource, setFileSource] = useState('local'); // 'local', 'onedrive', or 'dropbox'
  const [showOneDriveConnect, setShowOneDriveConnect] = useState(false);
  const [oneDriveConnected, setOneDriveConnected] = useState(false);
  const [showDropboxConnect, setShowDropboxConnect] = useState(false);
  const [dropboxConnected, setDropboxConnected] = useState(false);
  const [showQuickBooksModal, setShowQuickBooksModal] = useState(false);
  const [showDownloadOptions, setShowDownloadOptions] = useState(false);
  const [downloadLocation, setDownloadLocation] = useState('local');
  // Filter files based on search term and source
  const getFilteredFiles = () => {
    if (fileSource === 'local' && selectedFolder) {
      return selectedFolder.files.filter(file => file.name.toLowerCase().includes(searchTerm.toLowerCase()) || file.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())));
    } else if (fileSource === 'onedrive') {
      return mockOneDriveFiles.filter(file => file.name.toLowerCase().includes(searchTerm.toLowerCase()) || file.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())));
    } else if (fileSource === 'dropbox') {
      return mockDropboxFiles.filter(file => file.name.toLowerCase().includes(searchTerm.toLowerCase()) || file.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())));
    }
    return [];
  };
  const filteredFiles = getFilteredFiles();
  const handleFolderSelect = folder => {
    setSelectedFolder(folder);
    setSelectedFile(null);
    setFileSource('local');
  };
  const handleFileSelect = file => {
    setSelectedFile(file);
  };
  const handleBackToFolder = () => {
    setSelectedFile(null);
  };
  const handleConnectOneDrive = () => {
    // In a real app, this would initiate OAuth flow with Microsoft
    setShowOneDriveConnect(false);
    setOneDriveConnected(true);
    // After successful connection
    alert('OneDrive connected successfully!');
  };
  const handleConnectDropbox = () => {
    // In a real app, this would initiate OAuth flow with Dropbox
    setShowDropboxConnect(false);
    setDropboxConnected(true);
    // After successful connection
    alert('Dropbox connected successfully!');
  };
  const handleDownload = location => {
    setShowDownloadOptions(false);
    setDownloadLocation(location);
    // In a real app, this would initiate the download to the selected location
    alert(`File will be downloaded to ${location}`);
  };
  const handleViewOneDriveFiles = () => {
    setFileSource('onedrive');
    setSelectedFolder(null);
    setSelectedFile(null);
  };
  const handleViewDropboxFiles = () => {
    setFileSource('dropbox');
    setSelectedFolder(null);
    setSelectedFile(null);
  };
  const handleViewLocalFiles = () => {
    setFileSource('local');
    if (!selectedFolder) {
      setSelectedFolder(mockFolders[0]);
    }
    setSelectedFile(null);
  };
  return <div className="max-w-7xl mx-auto" data-id="element-622">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-623">File Cabinet</h1>
      {/* Integration status bar */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-3 mb-6" data-id="element-624">
        <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-625">
          <div className="flex items-center space-x-4" data-id="element-626">
            <div className="flex items-center" data-id="element-627">
              <div className={`w-2 h-2 rounded-full mr-2 ${oneDriveConnected ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-628"></div>
              <span className="text-sm font-medium" data-id="element-629">OneDrive</span>
              {!oneDriveConnected && <button className="text-blue-600 text-xs ml-2 hover:underline" onClick={() => setShowOneDriveConnect(true)} data-id="element-630">
                  Connect
                </button>}
            </div>
            <div className="flex items-center" data-id="element-631">
              <div className={`w-2 h-2 rounded-full mr-2 ${dropboxConnected ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-632"></div>
              <span className="text-sm font-medium" data-id="element-633">Dropbox</span>
              {!dropboxConnected && <button className="text-blue-600 text-xs ml-2 hover:underline" onClick={() => setShowDropboxConnect(true)} data-id="element-634">
                  Connect
                </button>}
            </div>
            <div className="flex items-center" data-id="element-635">
              <div className={`w-2 h-2 rounded-full mr-2 ${mockQuickBooksData.connected ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-636"></div>
              <span className="text-sm font-medium" data-id="element-637">QuickBooks</span>
              <Link to="/quickbooks" className="text-blue-600 text-xs ml-2 hover:underline" data-id="element-638">
                {mockQuickBooksData.connected ? 'View' : 'Connect'}
              </Link>
            </div>
          </div>
          <div data-id="element-639">
            <Link to="/quickbooks" data-id="element-640">
              <Button size="sm" variant="outline" data-id="element-641">
                <DatabaseIcon className="w-4 h-4 mr-2" data-id="element-642" />
                QuickBooks Dashboard
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-6" data-id="element-643">
        {/* Sidebar with folders */}
        <div className="w-full lg:w-64 flex-shrink-0" data-id="element-644">
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4" data-id="element-645">
            <div className="flex justify-between items-center mb-4" data-id="element-646">
              <h2 className="text-lg font-medium text-gray-900" data-id="element-647">Storage</h2>
              <Button size="sm" variant="outline" data-id="element-648">
                <FolderPlusIcon className="w-4 h-4 mr-1" data-id="element-649" />
                New
              </Button>
            </div>
            {/* File sources */}
            <div className="mb-4 pb-4 border-b border-gray-200" data-id="element-650">
              <button className={`w-full flex items-center px-3 py-2 rounded-md text-left mb-1 ${fileSource === 'local' ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} onClick={handleViewLocalFiles} data-id="element-651">
                <FolderIcon className={`w-5 h-5 mr-2 ${fileSource === 'local' ? 'text-blue-500' : 'text-gray-400'}`} data-id="element-652" />
                <span className="truncate" data-id="element-653">Local Storage</span>
              </button>
              <button className={`w-full flex items-center px-3 py-2 rounded-md text-left mb-1 ${fileSource === 'onedrive' ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} onClick={oneDriveConnected ? handleViewOneDriveFiles : () => setShowOneDriveConnect(true)} data-id="element-654">
                <CloudIcon className={`w-5 h-5 mr-2 ${fileSource === 'onedrive' ? 'text-blue-500' : 'text-gray-400'}`} data-id="element-655" />
                <span className="truncate" data-id="element-656">OneDrive</span>
                {!oneDriveConnected && <LinkIcon className="w-3 h-3 ml-1 text-gray-400" data-id="element-657" />}
              </button>
              <button className={`w-full flex items-center px-3 py-2 rounded-md text-left ${fileSource === 'dropbox' ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} onClick={dropboxConnected ? handleViewDropboxFiles : () => setShowDropboxConnect(true)} data-id="element-658">
                <svg className={`w-5 h-5 mr-2 ${fileSource === 'dropbox' ? 'text-blue-500' : 'text-gray-400'}`} viewBox="0 0 24 24" fill="currentColor" data-id="element-659">
                  <path d="M12 0L6 6 0 0v6l6 6-6 6v6l6-6 6 6 6-6-6-6 6-6V0l-6 6z" data-id="element-660" />
                </svg>
                <span className="truncate" data-id="element-661">Dropbox</span>
                {!dropboxConnected && <LinkIcon className="w-3 h-3 ml-1 text-gray-400" data-id="element-662" />}
              </button>
            </div>
            {/* Local folders */}
            {fileSource === 'local' && <div data-id="element-663">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-664">
                  Folders
                </h3>
                <div className="space-y-1" data-id="element-665">
                  {mockFolders.map(folder => <button key={folder.id} className={`w-full flex items-center px-3 py-2 rounded-md text-left ${selectedFolder && selectedFolder.id === folder.id ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => handleFolderSelect(folder)} data-id="element-666">
                      <FolderIcon className={`w-5 h-5 mr-2 ${selectedFolder && selectedFolder.id === folder.id ? 'text-blue-500' : 'text-gray-400'}`} data-id="element-667" />
                      <span className="truncate" data-id="element-668">{folder.name}</span>
                      <span className="ml-auto text-xs text-gray-500" data-id="element-669">
                        {folder.files.length}
                      </span>
                    </button>)}
                </div>
              </div>}
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-670">
              <Link to="/notes" className="w-full flex items-center px-3 py-2 rounded-md text-left text-gray-700 hover:bg-gray-100" data-id="element-671">
                <PencilIcon className="w-5 h-5 mr-2 text-gray-400" data-id="element-672" />
                <span data-id="element-673">Notes & Logs</span>
              </Link>
              <Link to="/todos" className="w-full flex items-center px-3 py-2 rounded-md text-left text-gray-700 hover:bg-gray-100" data-id="element-674">
                <TagIcon className="w-5 h-5 mr-2 text-gray-400" data-id="element-675" />
                <span data-id="element-676">To-Do Items</span>
              </Link>
              <Link to="/quickbooks" className="w-full flex items-center px-3 py-2 rounded-md text-left text-gray-700 hover:bg-gray-100" data-id="element-677">
                <DatabaseIcon className="w-5 h-5 mr-2 text-gray-400" data-id="element-678" />
                <span data-id="element-679">QuickBooks</span>
              </Link>
            </div>
          </div>
        </div>
        {/* Main content area */}
        <div className="flex-1" data-id="element-680">
          {selectedFile ? <DocumentViewer file={selectedFile} onBack={handleBackToFolder} dropboxConnected={dropboxConnected} oneDriveConnected={oneDriveConnected} showDownloadOptions={showDownloadOptions} setShowDownloadOptions={setShowDownloadOptions} handleDownload={handleDownload} data-id="element-681" /> : <div className="bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-682">
              {/* Folder header */}
              <div className="p-4 border-b border-gray-200" data-id="element-683">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-684">
                  <div className="flex items-center" data-id="element-685">
                    {fileSource === 'local' && selectedFolder ? <>
                        {selectedFolder.icon}
                        <h2 className="text-lg font-medium text-gray-900 ml-2" data-id="element-686">
                          {selectedFolder.name}
                        </h2>
                        <span className="ml-2 text-sm text-gray-500" data-id="element-687">
                          ({selectedFolder.files.length} files)
                        </span>
                      </> : fileSource === 'onedrive' ? <>
                        <CloudIcon className="w-5 h-5 text-blue-500" data-id="element-688" />
                        <h2 className="text-lg font-medium text-gray-900 ml-2" data-id="element-689">
                          OneDrive Files
                        </h2>
                        <span className="ml-2 text-sm text-gray-500" data-id="element-690">
                          ({mockOneDriveFiles.length} files)
                        </span>
                      </> : fileSource === 'dropbox' ? <>
                        <svg className="w-5 h-5 text-blue-600" viewBox="0 0 24 24" fill="currentColor" data-id="element-691">
                          <path d="M12 0L6 6 0 0v6l6 6-6 6v6l6-6 6 6 6-6-6-6 6-6V0l-6 6z" data-id="element-692" />
                        </svg>
                        <h2 className="text-lg font-medium text-gray-900 ml-2" data-id="element-693">
                          Dropbox Files
                        </h2>
                        <span className="ml-2 text-sm text-gray-500" data-id="element-694">
                          ({mockDropboxFiles.length} files)
                        </span>
                      </> : <h2 className="text-lg font-medium text-gray-900" data-id="element-695">
                        No folder selected
                      </h2>}
                  </div>
                  <div className="flex items-center gap-2" data-id="element-696">
                    <div className="relative" data-id="element-697">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-698">
                        <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-699" />
                      </div>
                      <input type="text" className="block w-full pl-9 pr-3 py-1.5 border border-gray-300 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Search files..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-700" />
                    </div>
                    <Button size="sm" data-id="element-701">
                      <UploadIcon className="w-4 h-4 mr-1" data-id="element-702" />
                      Upload
                    </Button>
                  </div>
                </div>
              </div>
              {/* File grid/list view */}
              <div className="p-4" data-id="element-703">
                <div className="flex justify-between items-center mb-4" data-id="element-704">
                  <div className="text-sm text-gray-500" data-id="element-705">
                    {filteredFiles.length} files
                  </div>
                  <div className="flex gap-2" data-id="element-706">
                    <button className={`p-1.5 rounded ${viewMode === 'grid' ? 'bg-gray-100 text-gray-800' : 'text-gray-500 hover:bg-gray-50'}`} onClick={() => setViewMode('grid')} data-id="element-707">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-708">
                        <rect x="3" y="3" width="7" height="7" data-id="element-709" />
                        <rect x="14" y="3" width="7" height="7" data-id="element-710" />
                        <rect x="14" y="14" width="7" height="7" data-id="element-711" />
                        <rect x="3" y="14" width="7" height="7" data-id="element-712" />
                      </svg>
                    </button>
                    <button className={`p-1.5 rounded ${viewMode === 'list' ? 'bg-gray-100 text-gray-800' : 'text-gray-500 hover:bg-gray-50'}`} onClick={() => setViewMode('list')} data-id="element-713">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-714">
                        <line x1="8" y1="6" x2="21" y2="6" data-id="element-715" />
                        <line x1="8" y1="12" x2="21" y2="12" data-id="element-716" />
                        <line x1="8" y1="18" x2="21" y2="18" data-id="element-717" />
                        <line x1="3" y1="6" x2="3.01" y2="6" data-id="element-718" />
                        <line x1="3" y1="12" x2="3.01" y2="12" data-id="element-719" />
                        <line x1="3" y1="18" x2="3.01" y2="18" data-id="element-720" />
                      </svg>
                    </button>
                  </div>
                </div>
                {filteredFiles.length === 0 ? <div className="text-center py-12" data-id="element-721">
                    <FileIcon className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-722" />
                    <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-723">
                      No files found
                    </h3>
                    <p className="text-gray-500 mb-4" data-id="element-724">
                      {searchTerm ? `No files matching "${searchTerm}" in this ${fileSource === 'local' ? 'folder' : 'location'}` : `This ${fileSource === 'local' ? 'folder' : 'location'} is empty`}
                    </p>
                    <Button data-id="element-725">
                      <UploadIcon className="w-4 h-4 mr-2" data-id="element-726" />
                      Upload Files
                    </Button>
                  </div> : viewMode === 'grid' ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-727">
                    {filteredFiles.map(file => <div key={file.id} className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-sm cursor-pointer transition-all" onClick={() => handleFileSelect(file)} data-id="element-728">
                        <div className="flex items-start justify-between mb-2" data-id="element-729">
                          <div className="flex items-center" data-id="element-730">
                            <FileIcon className="w-8 h-8 text-blue-500" data-id="element-731" />
                            <div className="ml-3" data-id="element-732">
                              <p className="font-medium text-gray-900 truncate max-w-[180px]" data-id="element-733">
                                {file.name}
                              </p>
                              <p className="text-xs text-gray-500" data-id="element-734">
                                {file.type} • {file.size}
                                {file.source && ` • ${file.source}`}
                              </p>
                            </div>
                          </div>
                          <button className="text-gray-400 hover:text-gray-600" data-id="element-735">
                            <MoreHorizontalIcon className="w-5 h-5" data-id="element-736" />
                          </button>
                        </div>
                        <div className="flex items-center justify-between mt-4" data-id="element-737">
                          <div className="flex items-center text-xs text-gray-500" data-id="element-738">
                            <CalendarIcon className="w-3.5 h-3.5 mr-1" data-id="element-739" />
                            <span data-id="element-740">{file.date}</span>
                          </div>
                          <div className="flex gap-1" data-id="element-741">
                            {file.tags.slice(0, 2).map((tag, index) => <span key={index} className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs" data-id="element-742">
                                {tag}
                              </span>)}
                            {file.tags.length > 2 && <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs" data-id="element-743">
                                +{file.tags.length - 2}
                              </span>}
                          </div>
                        </div>
                      </div>)}
                  </div> : <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-744">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-745">
                      <thead className="bg-gray-50" data-id="element-746">
                        <tr data-id="element-747">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-748">
                            Name
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-749">
                            Type
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-750">
                            Size
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-751">
                            Date
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-752">
                            Tags
                          </th>
                          {(fileSource === 'onedrive' || fileSource === 'dropbox') && <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-753">
                              Source
                            </th>}
                          <th scope="col" className="relative px-6 py-3" data-id="element-754">
                            <span className="sr-only" data-id="element-755">Actions</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-756">
                        {filteredFiles.map(file => <tr key={file.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleFileSelect(file)} data-id="element-757">
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-758">
                              <div className="flex items-center" data-id="element-759">
                                <FileIcon className="w-5 h-5 text-blue-500 mr-3" data-id="element-760" />
                                <span className="text-sm font-medium text-gray-900" data-id="element-761">
                                  {file.name}
                                </span>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-762">
                              {file.type}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-763">
                              {file.size}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-764">
                              {file.date}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-765">
                              <div className="flex gap-1" data-id="element-766">
                                {file.tags.slice(0, 2).map((tag, index) => <span key={index} className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs" data-id="element-767">
                                    {tag}
                                  </span>)}
                                {file.tags.length > 2 && <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs" data-id="element-768">
                                    +{file.tags.length - 2}
                                  </span>}
                              </div>
                            </td>
                            {(fileSource === 'onedrive' || fileSource === 'dropbox') && <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-769">
                                {file.source || (fileSource === 'onedrive' ? 'OneDrive' : 'Dropbox')}
                              </td>}
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-770">
                              <button className="text-gray-400 hover:text-gray-600" onClick={e => {
                        e.stopPropagation();
                      }} data-id="element-771">
                                <MoreHorizontalIcon className="w-5 h-5" data-id="element-772" />
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>}
              </div>
            </div>}
        </div>
      </div>
      {/* OneDrive Connect Modal */}
      {showOneDriveConnect && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-773">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md" data-id="element-774">
            <div className="text-center mb-6" data-id="element-775">
              <CloudIcon className="w-16 h-16 text-blue-500 mx-auto mb-4" data-id="element-776" />
              <h3 className="text-xl font-medium text-gray-900" data-id="element-777">
                Connect to OneDrive
              </h3>
              <p className="text-gray-500 mt-2" data-id="element-778">
                Link your Microsoft OneDrive account to access your files
                directly within the application.
              </p>
            </div>
            <div className="space-y-4" data-id="element-779">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-780">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-781">
                  Benefits of connecting:
                </h4>
                <ul className="text-sm text-gray-600 space-y-2" data-id="element-782">
                  <li className="flex items-start" data-id="element-783">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-784" />
                    <span data-id="element-785">
                      Access all your OneDrive files without leaving the app
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-786">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-787" />
                    <span data-id="element-788">Save files directly to OneDrive from the app</span>
                  </li>
                  <li className="flex items-start" data-id="element-789">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-790" />
                    <span data-id="element-791">Seamlessly share files with your team</span>
                  </li>
                </ul>
              </div>
              <p className="text-sm text-gray-500" data-id="element-792">
                By connecting, you agree to our terms of service and privacy
                policy regarding third-party integrations.
              </p>
            </div>
            <div className="flex justify-end mt-6 space-x-3" data-id="element-793">
              <Button variant="outline" onClick={() => setShowOneDriveConnect(false)} data-id="element-794">
                Cancel
              </Button>
              <Button onClick={handleConnectOneDrive} data-id="element-795">
                <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-796" />
                Connect to OneDrive
              </Button>
            </div>
          </div>
        </div>}
      {/* Dropbox Connect Modal */}
      {showDropboxConnect && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-797">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md" data-id="element-798">
            <div className="text-center mb-6" data-id="element-799">
              <svg className="w-16 h-16 mx-auto mb-4 text-blue-600" viewBox="0 0 24 24" fill="currentColor" data-id="element-800">
                <path d="M12 0L6 6 0 0v6l6 6-6 6v6l6-6 6 6 6-6-6-6 6-6V0l-6 6z" data-id="element-801" />
              </svg>
              <h3 className="text-xl font-medium text-gray-900" data-id="element-802">
                Connect to Dropbox
              </h3>
              <p className="text-gray-500 mt-2" data-id="element-803">
                Link your Dropbox account to enable saving and sharing files
                directly to your Dropbox.
              </p>
            </div>
            <div className="space-y-4" data-id="element-804">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-805">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-806">
                  Benefits of connecting:
                </h4>
                <ul className="text-sm text-gray-600 space-y-2" data-id="element-807">
                  <li className="flex items-start" data-id="element-808">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-809" />
                    <span data-id="element-810">Save documents directly to your Dropbox</span>
                  </li>
                  <li className="flex items-start" data-id="element-811">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-812" />
                    <span data-id="element-813">
                      Easily share files with others via Dropbox links
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-814">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-815" />
                    <span data-id="element-816">
                      Keep your important documents backed up in the cloud
                    </span>
                  </li>
                </ul>
              </div>
              <p className="text-sm text-gray-500" data-id="element-817">
                We'll only request access to the specific folders needed for
                this application.
              </p>
            </div>
            <div className="flex justify-end mt-6 space-x-3" data-id="element-818">
              <Button variant="outline" onClick={() => setShowDropboxConnect(false)} data-id="element-819">
                Cancel
              </Button>
              <Button onClick={handleConnectDropbox} data-id="element-820">
                <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-821" />
                Connect to Dropbox
              </Button>
            </div>
          </div>
        </div>}
    </div>;
};
export default FileCabinet;